import type { ComplianceRule } from '@/types/simulation'

interface Props {
  rules: ComplianceRule[]
}

const STATUS_ICON: Record<ComplianceRule['status'], string> = {
  ok: '✓',
  warning: '⚠',
  violation: '✗',
}

const STATUS_COLOR: Record<ComplianceRule['status'], string> = {
  ok: 'text-gain',
  warning: 'text-bernstein-dim',
  violation: 'text-loss',
}

export function ComplianceCard({ rules }: Props) {
  const fmtPct = (s: string) => `${(Number(s) * 100).toFixed(1)}%`

  return (
    <div className="border border-hairline bg-panel p-4">
      <div className="tracked-caps mb-3 text-[10px] text-faint">Regel-Compliance</div>
      <div className="space-y-1 text-sm text-ink">
        {rules.length === 0 && <div className="text-muted">Keine Rules aktiv.</div>}
        {rules.map((r) => (
          <div key={r.rule_id} className="flex justify-between">
            <span>
              <span className={STATUS_COLOR[r.status]}>{STATUS_ICON[r.status]}</span> {r.name}{' '}
              <span className="text-muted">≤ {fmtPct(r.limit)}</span>
            </span>
            <span className="font-mono text-muted">
              aktuell: <span className="text-ink">{fmtPct(r.actual_after)}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
